import { render } from "./TextConfirmField.vue?vue&type=template&id=0f54c32e"
import script from "./TextConfirmField.vue?vue&type=script&lang=js"
export * from "./TextConfirmField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__